/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyRefreshStatus } from '../models/CompanyRefreshStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QuickSightService {

    /**
     * Returns the Company Refresh Status
     * @returns CompanyRefreshStatus Success
     * @throws ApiError
     */
    public static getCompanyRefreshStatus(): CancelablePromise<CompanyRefreshStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/quickSight/companyStatus',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Returns the list of dashboards for user to view
     * @returns any[] Success
     * @throws ApiError
     */
    public static getDashboards({
        search,
        sort,
    }: {
        /**
         * Dashboard name
         */
        search?: string,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
    }): CancelablePromise<any[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/quickSight/dashboard',
            query: {
                'search': search,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Returns a dashboard embed url
     * @returns string Success
     * @throws ApiError
     */
    public static getDashboardEmbedUrl({
        id,
        reportId,
    }: {
        /**
         * dashboardId to embed
         */
        id: string,
        /**
         * Analytics Report to embed
         */
        reportId?: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/quickSight/dashboard/{id}',
            path: {
                'id': id,
            },
            query: {
                'reportId': reportId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns Quicksight URL to embed dashboard
     * @returns string Success
     * @throws ApiError
     */
    public static getAuthorEmbedUrl(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/quickSight/author',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
